module.exports = __webpack_public_path__ + "img/form-a11y-0.6c45a070.png";